import axios from 'axios';


export const getUserImages = async (type: string, ids: string[], accessToken: string) => {
    const response = await axios.post(`${import.meta.env.VITE_USER_API_URL}/common/user-images`, { type, ids }, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    })
    return response.data
}

export const getCurrentNotice=async (accessToken: string)=>{
    const date = new Date();
    const response = await axios.get(`${import.meta.env.VITE_USER_API_URL}/common/notices/current?date=${date}`,{headers: {Authorization: `Bearer ${accessToken}`}});
    return response.data;
}

